import { useRef } from "react";
import useDashboardContext from "routes/utils/context/useDashboardContext";
import { configSessionStorage } from "services/storage/config";

const { campus, spaceTypeId } = configSessionStorage.spaceAdmin;
const usePreselectedData = ({
    isUpdate
}) => {
    const { userCampusId } = useDashboardContext();
	const preselectedData = useRef(getData()).current;
    function getData() {
        if (isUpdate) 
            return { campusId: 0, spaceTypeId: 0 };
        return {
            campusId: userCampusId || campus.get()?.id || 0,
            spaceTypeId: spaceTypeId.get() || 0
        };
    }
	return preselectedData;
}	
	
export default usePreselectedData;